export const ADS_BLOCKS = {
  FINANCE: {
    id: 'financial-aid',
    title: 'Unlock Financial Aid View',
    description:
      'Achieve your revenue goals by understanding your institution’s pricing power through industry-leading comparative context, allowing you to make more informed awarding decisions.',
    buttonText: 'Talk to us',
    bgSmall: 'finance-bg-md',
    bgLarge: 'finance-bg-lg',
    type: 'FINANCIAL_AID_VIEW',
  },
  RETENTION: {
    id: 'retention',
    title: 'Unlock Retention View',
    description:
      'Reach your retention goals through the ability to link demographic data and pre-enrollment characteristics on a student level for more productive intervention in reducing attrition risk.',
    buttonText: 'Talk to us',
    bgSmall: 'retention-bg-md',
    bgLarge: 'retention-bg-lg',
    type: 'RETENTION_VIEW',
  },
};
